export default __webpack_public_path__ + "static/media/irjon_nekunk_v.04c386bd.jpg";